/**
 * @generated SignedSource<<048e4a508e186cd3fc1004ba1a7fd099>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceModalChartSection_projectStats$data = ReadonlyArray<{
  readonly id: string;
  readonly date: string | null;
  readonly performance: number | null;
  readonly optimisticPerformance: number | null;
  readonly conservativePerformance: number | null;
  readonly " $fragmentType": "PerformanceModalChartSection_projectStats";
}>;
export type PerformanceModalChartSection_projectStats$key = ReadonlyArray<{
  readonly " $data"?: PerformanceModalChartSection_projectStats$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceModalChartSection_projectStats">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PerformanceModalChartSection_projectStats",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "performance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optimisticPerformance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "conservativePerformance",
      "storageKey": null
    }
  ],
  "type": "ProjectStats",
  "abstractKey": null
};

(node as any).hash = "fd4afecea4c4fc08e771a4b0e2e82d9c";

export default node;
